<template>
  <div>
    <v-tooltip v-for="(language, idx) in $_config.languages" :key="idx" color="tooltip" top>
      <template #activator="{ on }">
        <v-btn
          v-on="on"
          :ripple="false"
          icon
          depressed
          x-small
          :class="{ 'mr-5': !idx }"
          @click="changeLanguage(language)"
        >
          <img :src="require(`@/assets/images/flag-${language}.png`)" />
        </v-btn>
      </template>
      {{ $i18n.t(`languages.${language}`) }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'LanguagePicker',
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
      this.$vuetify.lang.current = language;
      this.$dayjs.locale(language);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn::before {
  background-color: transparent;
}
</style>
